import Vue from "vue"

/*
 * What the bar at the top of the family's panel should say.
 *
 * Most screens know their own name before they have loaded anything, so they
 * declare it in the route and the layout reads it there. The child's page is
 * the exception: its name is the child's, and nobody knows that until the list
 * of children comes back. So it sets it here when it does, and clears it on
 * the way out - otherwise the next screen opens still wearing the last child's
 * name for as long as it takes to load.
 */
export const portalChrome = Vue.observable({
  title: null,
})

/** Called by a screen whose name is not knowable from the route alone. */
export function nameTheScreen(title) {
  portalChrome.title = title || null
}

export function forgetTheScreen() {
  portalChrome.title = null
}

export default portalChrome
